import { colors } from 'styles/colors';
import styled from 'styled-components';

export const Wrapper = styled.section`
  background: ${colors.sand};
`;

export const Poem = styled.blockquote`
  margin: 2.5rem 0;
  padding: 0.25rem 0 0.25rem 1.5rem;
  border-left: 3px solid ${colors.sea};
  font-family: 'Lora', Georgia, 'Times New Roman', serif;
  font-size: 1.25em;
  font-style: italic;
  line-height: 1.8em;
  color: ${colors.ink};

  p {
    margin: 0;
  }
`;
